import type { ComponentProps } from "react";

import { Dialog } from "../../atoms/Dialog";
import { cn } from "../../lib/utils";

export type ConfirmDialogBodyProps = ComponentProps<typeof Dialog.Body>;

/**
 * Extra content between the description and the buttons, aligned with the title: a required reason
 * field (pair it with `confirmDisabled`), a summary of what will change, a list of affected items.
 * Optional: a plain question needs only `title` and `description`. Must be a direct child of
 * `ConfirmDialog`, which moves it into the dialog; a Body wrapped in another component is not found.
 */
export const ConfirmDialogBody = ({ className, ...props }: ConfirmDialogBodyProps) => (
  <Dialog.Body data-slot="confirm-dialog-body" className={cn("pl-12", className)} {...props} />
);

ConfirmDialogBody.displayName = "ConfirmDialog.Body";
